<template>
    <div>
        <b-container>
            <b-row align-h="center">
                <b-col cols="8">
                    <b-card-group deck>
                        <b-card header="Configure the Stack Integration" header-tag="header">
                            <b-container>
                                <b-row align-h="center">
                                    <b-col cols="8">
                                        <b-form @submit.prevent="updateStack">
                                            <b-form-group
                                                id="input-group-1"
                                                label="Enter your Stack Partner Id"
                                                label-for="stackPartnerId">
                                                <b-form-input
                                                    id="stackPartnerId"
                                                    v-model="stackPartnerId"
                                                    type="text"
                                                    placeholder="Partner Id">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-form-group
                                                id="input-group-2"
                                                label="Enter your Partner Secret Key"
                                                label-for="stackSecretKey">
                                                <b-form-input
                                                    id="stackSecretKey"
                                                    v-model="stackSecretKey"
                                                    type="text"
                                                    placeholder="Partner Secret Key">
                                                </b-form-input>
                                            </b-form-group>
                                            <b-button :disabled="isLoading" type="submit" variant="primary">
                                                Save
                                                <i v-if="isLoading"
                                                   class="fa fa-spin fa-spinner text-grey-darkest"
                                                   aria-hidden="true">
                                                </i>
                                            </b-button>
                                        </b-form>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
export default {
    name: 'stack-integration',
    data() {
        return {
            stackPartnerId: '',
            stackSecretKey: ''
        }
    },
    methods: {
        updateStack() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            this.isLoading = true;
            axios.post(route('api.settings.stack'),
                {
                    stackPartnerId: this.stackPartnerId,
                    stackSecretKey: this.stackSecretKey
                }).then((StackResp) => {
                //console.log('StackResp', StackResp.data.status);
                if (StackResp.data.status) {
                    Toast.fire({
                        type: 'success',
                        title: "Your Stack Integration has been updated."
                    });
                } else {
                    Toast.fire({
                        type: 'error',
                        title: StackResp.data.message
                    });
                }
            }).catch(() => {
                Toast.fire({
                    type: 'error',
                    title: "Error on update your Stack Integration."
                });
            }).finally(() => {
                this.isLoading = false;
            })
        },
    }
}
</script>

<style scoped>

</style>
